import { render, staticRenderFns } from "./UiBaseIcon.vue?vue&type=template&id=41fa794e&scoped=true"
import script from "./UiBaseIcon.vue?vue&type=script&lang=js"
export * from "./UiBaseIcon.vue?vue&type=script&lang=js"
import style0 from "./UiBaseIcon.vue?vue&type=style&index=0&id=41fa794e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41fa794e",
  null
  
)

export default component.exports